/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export enum ImageResolutionEnum {
    "high" = "high",
    "low" = "low"
}

export type ImageResolution = ImageResolutionEnum;